import { Tooltip, colors, sizing } from '@chillibean/component-library';
import { ActivityIndicator } from '@chillibean/component-library/legacy';
import { Icon } from '@iconify/react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function IconList(props) {
  const { disabled = false, icons } = props;

  const handleIconClick = ({ callback, event, iconDisabled, id }) => {
    if (iconDisabled) return;

    event.stopPropagation();
    callback(id);
  };

  return (
    <IconsContainer>
      {icons.map((icon) => {
        const isDisabled = icon.disabled || disabled;

        return (
          <Tooltip key={icon.key} content={!isDisabled && icon.tooltip ? icon.tooltip : null} id={icon.key}>
            <IconContainer
              className={clsx({
                disabled: isDisabled,
                hover: icon.withHover,
              })}
              onClick={(event) =>
                handleIconClick({ callback: icon.onClick, event: event, iconDisabled: icon.disabled, id: icon.id })
              }
            >
              {icon.loading ? (
                <ActivityIndicator />
              ) : (
                <Icon
                  color={isDisabled ? colors.grey.secondary : colors.black.medium}
                  height={icon.height}
                  icon={icon.element}
                  width={icon.width}
                />
              )}
            </IconContainer>
          </Tooltip>
        );
      })}
    </IconsContainer>
  );
}

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div:not(:last-child) {
    margin-right: ${sizing.medium};
  }
`;

const IconContainer = styled.div`
  cursor: default;
  width: 32px;

  &.hover {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
      transition: opacity 0.3s ease-in-out;
    }
  }
`;

IconList.propTypes = {
  disabled: PropTypes.bool,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      element: PropTypes.shape({}),
      height: PropTypes.number,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      key: PropTypes.string,
      loading: PropTypes.bool,
      onClick: PropTypes.func,
      tooltip: PropTypes.string,
      width: PropTypes.number,
      withHover: PropTypes.bool,
    }),
  ).isRequired,
};

export default IconList;
